import { SegmentItem } from 'features/segment-controls/segment-controls.types';
import { queryApi } from '../queryApi';
import { GetAllSegmentsDto } from './segmentation-api.types';

function isInsightRequest(componentId: string) {
  return componentId === 'ConversionInfluence';
}

const segmentsEndpoints = queryApi.injectEndpoints({
  endpoints: (builder) => ({
    getAdvancedReportsSegments: builder.query<
      GetAllSegmentsDto[],
      { siteId: string; componentId: string }
    >({
      query: (request) => `${request.siteId}/segmentation/segments`,
      transformResponse: (response: GetAllSegmentsDto[]) =>
        response.map<SegmentItem>((r) => ({
          segmentTypeName: r.segmentTypeName,
          segmentTypeDisplayName: r.segmentTypeDisplayName,
          customDataKey: r.customDataKey,
          customDataKeyDisplayName: r.customDataKeyDisplayName,
          isPocOnly: r.isPocOnly
        }))
    }),
    getInsightsSegments: builder.query<
      GetAllSegmentsDto[],
      { siteId: string; componentId: string; insightType: string }
    >({
      query: (request) => {
        return {
          url: `${request.siteId}/insights/segments`,
          params: {
            insightType: request.insightType
          }
        };
      },
      transformResponse: (response: GetAllSegmentsDto[]) =>
        response.map<SegmentItem>((r) => ({
          segmentTypeName: r.segmentTypeName,
          segmentTypeDisplayName: r.segmentTypeDisplayName,
          customDataKey: r.customDataKey,
          customDataKeyDisplayName: r.customDataKeyDisplayName,
          isPocOnly: r.isPocOnly
        }))
    })
  }),
  overrideExisting: false
});

export const segmentationQueryApi = queryApi.injectEndpoints({
  endpoints: (builder) => ({
    getSegments: builder.query<
      GetAllSegmentsDto[],
      {
        siteId: string;
        componentId: string;
      }
    >({
      queryFn: async (request, api) => {
        let resultData;
        if (isInsightRequest(request.componentId)) {
          resultData = await api.dispatch(
            segmentsEndpoints.endpoints.getInsightsSegments.initiate({
              siteId: request.siteId,
              componentId: request.componentId,
              insightType: request.componentId
            })
          );
        } else {
          try {
            resultData = await api.dispatch(
              segmentsEndpoints.endpoints.getAdvancedReportsSegments.initiate({
                siteId: request.siteId,
                componentId: request.componentId
              })
            );
          } catch (ex) {
            console.error(ex);
          }
        }
        return { data: resultData?.data ?? [] };
      }
    })
  }),
  overrideExisting: false
});

export const { useGetSegmentsQuery } = segmentationQueryApi;
